export default "__VITE_ASSET__Bzx8X52f__"